import { render, staticRenderFns } from "./caseMaterialOptions.vue?vue&type=template&id=90735bda&scoped=true&"
import script from "./caseMaterialOptions.vue?vue&type=script&lang=js&"
export * from "./caseMaterialOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90735bda",
  null
  
)

export default component.exports